import { render, staticRenderFns } from "./AttachmentList.vue?vue&type=template&id=78c6a440&lang=pug"
import script from "./AttachmentList.vue?vue&type=script&lang=ts"
export * from "./AttachmentList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports